// The Sample data switch on the Admin page, and what a click on a sample row does.
// See client/sample.ts: nothing here reaches the server.
import { toast } from './dialog.ts';
import { esc } from './fmt.ts';
import { previewNews } from './whatsnew.ts';
import { latestNews } from '../shared/whatsnew.ts';
import { isSampleAdmin, sampleOn, setSampleEnabled } from './sample.ts';

/** The Admin page's row: one switch, remembered in this browser. */
export function sampleAdminRow(): string {
  if (!isSampleAdmin()) return '';
  const on = sampleOn();
  return `<h4 class="adm-h">Review</h4>
    <div class="actions smp-admin"><label class="row"><input type="checkbox" class="toggle" data-act="sample-toggle"${on ? ' checked' : ''} aria-label="Sample data"> <b>Sample data</b></label>
      <span class="muted">Fills Market, Records, Friends and thin leaderboards with generated rows tagged Sample. Only in this browser; nothing is sent.</span></div>
    <div class="actions"><button class="btn small" data-act="news-preview">Preview What's new</button>
      <span class="muted">${latestNews() ? `Newest entry: ${esc(latestNews()!.title)}.` : 'No entry yet, so this shows the layout sample. Players see nothing.'}</span></div>`;
}

export function sampleClick(el: HTMLElement, rerender: () => void): boolean {
  switch (el.dataset.act) {
    case 'news-preview': previewNews(); return true;
    case 'sample-row': toast('Sample data: shown for review only'); return true;
    case 'sample-toggle':
      if (!isSampleAdmin()) return true;
      setSampleEnabled(!sampleOn());
      toast(sampleOn() ? 'Sample data on' : 'Sample data off');
      rerender();
      return true;
    default: return false;
  }
}
